import React from "react";
import styles from "./Table.module.css";

export const Table = () => {
    return (
        <div className={styles.container}>
            <div className={styles.header}>
            Экспорт/импорт
            </div>
            <input
                type="text"
                placeholder="Поиск"
                className={styles.search}
            />
            <div className={styles.tableTitle}>
            Экспорт/импорт
            </div>
                    <div className={styles.tableRow}>
                    Россия - 760 млн $
              
                    </div>   
                    <div className={styles.tableRow}>
                
                    Казахстан - 200 млн $
                    </div>     
        </div>
    );
};   